module.exports = __webpack_public_path__ + "img/PC1.93eb1742.png";